/**
 * Whether a help anchor is connected, passes CSS visibility (incl. ancestors where supported),
 * and has a non‑zero layout box. Used by the help drawer and walkthrough overlay so conditional
 * controls (e.g. *ngIf) do not count as “on this page.”
 */
export function isHelpTargetElementVisible(el: HTMLElement | null | undefined): boolean {
  if (!el?.isConnected) {
    return false;
  }
  if (typeof el.checkVisibility === 'function') {
    if (!el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) {
      return false;
    }
  } else {
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
      return false;
    }
  }
  const r = el.getBoundingClientRect();
  return r.width > 0 && r.height > 0;
}
